import React from 'react';
import { View } from 'react-native';
import { StatusBar, DeviceInfo } from 'qunar-react-native';
import routerPlugin from './routerPlugin';
// import SearchListView from '../OrderMain/OrderMainView/Views/SearchListView/index';
import {SearchListView} from '@qnpm/cmn-component-order';
import {qav} from '../../utils/qav'

class SearchResult extends QView<any, any> {
    public static routerPlugin = routerPlugin;

    public static bindEvents = {
        actived() {
            qav({
                bizType: 'pp',
                module: 'page',
                page: 'orderqueryresult',
                operType: 'show',
                operTime: Date.now()
            });
        }
    };

    public componentDidMount() {
        // const { param = {} } = this.props;
        // const {
        //     source: sourceFrom = 'list',
        //     ordertoken = '',
        //     businessType: businessId = 'all'
        // } = param;

        // rootStore.setOrdertoken(ordertoken);
        // // 设置页面访问来源
        // rootStore.uiState.setSourceFrom(sourceFrom);
        // const isCold = false;
        // rootStore.resetPage(businessId, isCold);

        if (DeviceInfo.isIOS || (!DeviceInfo.isIOS && Number(DeviceInfo.vid) > 60001224)) {
            StatusBar.setStyle(
                'dark',
                () => {},
                () => {}
            );
        }
    }

    public render() {
        const { param = {} } = this.props;
        return (
            <View style={{ flex: 1 }}>
                <SearchListView {...param} />
            </View>
        );
    }
}

export default SearchResult;
